(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  var items = document.querySelectorAll('.faq-item__btn');
  items.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.faq-item');
      var isOpen = item.classList.contains('faq-item--open');
      document.querySelectorAll('.faq-item--open').forEach(function(el) {
        el.classList.remove('faq-item--open');
        el.querySelector('.faq-item__btn').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('faq-item--open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  var burger = document.querySelector('.header__burger');
  var mobileNav = document.getElementById('mobile-nav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function() {
      var isOpen = mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(isOpen));
      mobileNav.setAttribute('aria-hidden', String(!isOpen));
    });
  }

  document.querySelectorAll('.header__nav-link--dropdown').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var dropdown = btn.nextElementSibling;
      var isOpen = dropdown.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
      document.querySelectorAll('.header__dropdown.is-open').forEach(function(el) {
        if (el !== dropdown) {
          el.classList.remove('is-open');
          el.previousElementSibling.setAttribute('aria-expanded', 'false');
        }
      });
    });
  });

  document.addEventListener('click', function() {
    document.querySelectorAll('.header__dropdown.is-open').forEach(function(el) {
      el.classList.remove('is-open');
      el.previousElementSibling.setAttribute('aria-expanded', 'false');
    });
  });

  document.querySelectorAll('.header__mobile-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var children = btn.nextElementSibling;
      var isOpen = children.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(isOpen));
    });
  });

  // The menu items and the logo are merchant-editable, so a fixed breakpoint
  // can only ever be a guess. Measure the nav's natural width and fall back to
  // the burger menu whenever it no longer fits — this stops the nav from
  // overflowing its container and painting over the logo.
  var header = document.getElementById('site-header');
  var nav = header && header.querySelector('.header__nav');
  var navList = nav && nav.querySelector('.header__nav-list');

  function navFits() {
    var items = navList.children;
    var styles = window.getComputedStyle(navList);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    var needed = gap * Math.max(0, items.length - 1);
    for (var i = 0; i < items.length; i++) {
      needed += items[i].getBoundingClientRect().width;
    }
    // scrollWidth is unreliable here: a flex row justified to flex-end
    // overflows out of its start edge, which scrollWidth does not report.
    return needed <= nav.clientWidth + 1;
  }

  function syncNav() {
    header.classList.remove('site-header--collapsed');
    if (window.getComputedStyle(nav).display === 'none') return; // CSS already collapsed it
    if (!navFits()) {
      header.classList.add('site-header--collapsed');
      document.querySelectorAll('.header__dropdown.is-open').forEach(function(el) {
        el.classList.remove('is-open');
        el.previousElementSibling.setAttribute('aria-expanded', 'false');
      });
    }
  }

  if (nav && navList && navList.children.length) {
    var queued = false;
    window.addEventListener('resize', function() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function() { queued = false; syncNav(); });
    });
    syncNav();
    // Web fonts change text widths after first paint, so re-measure once loaded.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncNav);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  var slider = document.getElementById('heroSlider');
  var dotsContainer = document.getElementById('heroDots');
  if (!slider) return;

  var slides = slider.querySelectorAll('.hero-slide');
  var dots = dotsContainer ? dotsContainer.querySelectorAll('.hero__dot') : [];
  var current = 0;
  var total = slides.length;
  var timer = null;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    if (dots[current]) dots[current].classList.remove('is-active');
    current = (index + total) % total;
    slides[current].classList.add('is-active');
    if (dots[current]) dots[current].classList.add('is-active');
  }

  function startAuto() {
    if (total < 2) return;
    timer = setInterval(function() { goTo(current + 1); }, 6000);
  }

  function resetAuto() {
    clearInterval(timer);
    startAuto();
  }

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { goTo(i); resetAuto(); });
  });

  var prevBtn = document.querySelector('.hero__arrow--prev');
  var nextBtn = document.querySelector('.hero__arrow--next');
  if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); resetAuto(); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); resetAuto(); });

  startAuto();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["program-tabs"] && !Shopify.designMode) return;
  try {
    
(function() {
  var btns = document.querySelectorAll('.pt-tab-btn');
  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var tabId = btn.dataset.tab;
      document.querySelectorAll('.pt-tab-btn').forEach(function(b) {
        b.classList.remove('pt-tab-btn--active');
        b.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.pt-panel').forEach(function(p) {
        p.classList.remove('pt-panel--active');
        p.setAttribute('aria-hidden', 'true');
      });
      btn.classList.add('pt-tab-btn--active');
      btn.setAttribute('aria-selected', 'true');
      var panel = document.getElementById('pt-panel-' + tabId);
      if (panel) {
        panel.classList.add('pt-panel--active');
        panel.setAttribute('aria-hidden', 'false');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.tm-carousel').forEach(function(carousel) {
    var track = carousel.querySelector('.tm-track');
    var slides = carousel.querySelectorAll('.tm-slide');
    var dotsContainer = carousel.querySelector('.tm-dots');
    var prevBtn = carousel.querySelector('.tm-btn--prev');
    var nextBtn = carousel.querySelector('.tm-btn--next');
    var total = slides.length;
    var current = 0;
    var speed = parseInt(carousel.dataset.speed, 10) * 1000;
    var timer = null;

    if (total <= 1) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      return;
    }

    var dots = [];
    slides.forEach(function(_, i) {
      var dot = document.createElement('button');
      dot.className = 'tm-dot' + (i === 0 ? ' tm-dot--active' : '');
      dot.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
      dot.setAttribute('role', 'tab');
      dot.addEventListener('click', function() { goTo(i); resetTimer(); });
      dotsContainer.appendChild(dot);
      dots.push(dot);
    });

    function goTo(index) {
      current = (index + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function(d, i) {
        d.classList.toggle('tm-dot--active', i === current);
      });
    }

    function resetTimer() {
      clearInterval(timer);
      if (speed > 0) {
        timer = setInterval(function() { goTo(current + 1); }, speed);
      }
    }

    prevBtn.addEventListener('click', function() { goTo(current - 1); resetTimer(); });
    nextBtn.addEventListener('click', function() { goTo(current + 1); resetTimer(); });

    var startX = 0;
    track.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function(e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { goTo(diff > 0 ? current + 1 : current - 1); resetTimer(); }
    });

    resetTimer();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
